import React, { FC, useState } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import  Datepicker from "../../generic/Datepicker";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import EmployeePicker from "./EmployeePicker";
import { onAddSubordinate } from "../../../services/employee";

export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const departmentPickhook = usePickerhook();
  const { setLoading } = useStateSetter();
  const { AddEmployee } = useEmployeeHook();
  const { selectedOrgEmployees } = useEmployeeHook();
  const watchedFields = watch(["title", "description"]);
  const { SelectedOrg, config, selectedEmployee } = useStateGetter();
  const { UserOrgs } = useOrganizationHook();
  const [selectedSub, setselectedSub] = useState([]);
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" && field !== undefined && departmentPickhook.pickedRole
  );
  const onSubmit = async () => {



   await Promise.all( selectedSub.map(async (item: any) => {
      let postdata = {
        lineManagerID: selectedEmployee.id,
        subOrdinateID: item.id,
        organizationID: SelectedOrg.id,
      };

      try {
        setLoading(true);
        var res = await onAddSubordinate(postdata, config);

        toast.success(res.message);
      } catch (e: any) {
        toast.error(e);
      } finally {
        setLoading(false);
      }
    }));

props.show(false)
 await props.refresh()
  };

  const employeepickHook = usePickerhook();

  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm ">Add subordinate</p>
          <div className="">
            <EmployeePicker
              fullwidth
              hook={employeepickHook}
              setselectedSub={setselectedSub}
              selectedSub={selectedSub}
              title="Subordinate"
              // List of all other employees except the line manager 
              list={selectedOrgEmployees.filter((k:any)=>k.id!=selectedEmployee.id)}
            />
          </div>

          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!(selectedSub.length > 0)}
              text="Add Subordinate"
              onBtnClick={onSubmit}
            />
          </div>
        </div>
      </div>
    </>
  );
};
